import '../Styles/Areas.css';

import Navbar from '../Components/Navbar';
import { useTranslation } from 'react-i18next';
import * as yup from "yup"
import { useRef, useEffect, useState } from 'react';
import { useNavigate } from "react-router-dom";
import { useFormik } from "formik";
import { BeatLoader } from 'react-spinners';
import noResults from "../Images/noResults.svg"
import { countries, addUser, addUser2 } from '../api';
import { parsePhoneNumberFromString } from 'libphonenumber-js';
import { getCountryCallingCode } from 'libphonenumber-js';



function AddCustomer() {
  const safeParse = (key, fallback = {}) => {
  try {
    const value = localStorage.getItem(key);
    return value ? JSON.parse(value) : fallback;
  } catch (err) {
    console.error(`❌ Failed to parse ${key}:`, err);
    // Optional: clear the invalid value
    localStorage.removeItem(key);
    // Redirect or return fallback
    history("/"); // 👈 go back if corrupted
    return fallback;
  }
};

  const { t, i18n } = useTranslation();
  const phone = safeParse("customerPhone");
  const [country, setCountry] = useState([]);
  let history = useNavigate()
  const [selectedCountry, setSelectedCountry] = useState();
  const [msgAr, setMsgAr] = useState();
  const [msgEn, setMsgEn] = useState();
  const [loading, setLoading] = useState(true);
  const [submitLoading, setSubmitLoading] = useState(false);
  const [errorMsgModel, setErrorMsgModel] = useState(false);
  const nameRef = useRef();
  const phoneRef = useRef();


  


  const phoneRegEx =
    /^(05)[0-9]{8}$|^(03)[0-9]{8}$|^(3)[0-9]{7}$|^(6)[0-9]{7}$|^(7)[0-9]{7}$/;



  const validatePhone = (phone) => {
    try {
      return phoneRegEx.test(phone);
    } catch (error) {
      console.error("❌ Error validating phone number:", error);
      return false;
    }
  };

  const Schema = yup.object().shape({
    name: yup.string().required("validation.cstmrName_required"),
    phone: yup
      .string()
      .required("validation.cstmrPhone_required")
      .test(
        "is-valid-phone",
        "validation.cstmrPhone_not_valid",
        function (value) {
          return validatePhone(value);
        }
      ),
  });

  const formik = useFormik({
    initialValues: {
      name: "",
      phone: "",
    },
    validationSchema: Schema,
    onSubmit,
  });


  const storedPhone = JSON.parse(localStorage.getItem("customerPhone") || "{}");
  const numericCountryCode = storedPhone.countryCode ? getCountryCallingCode(storedPhone.countryCode) : "";



  //takes token and calls api to get all countries
  //sets default selected country
  useEffect(() => {

    const token = localStorage.getItem("token");
    const storedPhone = safeParse("customerPhone", {});

    // ✅ Redirect if missing or invalid phone
    if (!storedPhone || !storedPhone.phone) {
      history("/");
      return;
    }

    if (storedPhone?.phone) {
      formik.setFieldValue("phone", storedPhone.phone);
    }



    countries(token).then((response) => {
      setCountry(response.data.data)
      setSelectedCountry(response.data.data[0].id)

      setLoading(false)
    }).catch(function (error) {
      if (error.response.status === 401) {
        history("/")
      }

    });


  }, [])

  //takes name,phone and country id
  //if success => stores client data and redirects to the client's profile
  function onSubmit(event) {
    setSubmitLoading(true)
    const token = localStorage.getItem("token");

    console.log(phoneRef)

    const stored = JSON.parse(localStorage.getItem("customerPhone") || "{}");
    const rawPhone = formik.values.phone ?? "";
    const cleanedPhone = rawPhone.replace(/\s/g, "");

    // if (!stored.countryCode || !cleanedPhone) {
    //   console.error("❌ Missing phone or country code");
    //   setSubmitLoading(false);
    //   return;
    // }

    const fullNumber = `+${stored.countryCode}${cleanedPhone}`;
    const phoneNumber = parsePhoneNumberFromString(fullNumber);



    const data = {
      name: formik.values.name,
      phone: formik.values.phone,
      // countryCode: stored.countryCode,
      // countryId: selectedCountry,
    };

    console.log(data)

    addUser2(token, data).then((response) => {
      if (response.data.message === "success") {
        localStorage.setItem("customerId", response.data.data.id);
        localStorage.setItem("customerName", response.data.data.name);
        localStorage.setItem("customerPhone", response.data.data.phone);
        localStorage.setItem("customerPhoto", response.data.data.photo);
        history("/add-order")
      } else {
        setErrorMsgModel(true)
        setMsgAr("حدث خطأ")
        setMsgEn("Something went wrong")
        setSubmitLoading(false)
      }
    }).catch(function (error) {
      if (error.response.data.error === "phone_exist") {
        setErrorMsgModel(true)
        setMsgAr("هذا الرقم مسجل من قبل")
        setMsgEn("This phone is exist")
        setSubmitLoading(false)

      }
      else if (error.response.status === 401) {
        history("/")

      }
      else {
        setErrorMsgModel(true)
        setMsgAr("حدث خطأ")
        setMsgEn("Something went wrong")
        setSubmitLoading(false)

      }

    });

  }


  return (
    <div >


      {loading ?
        <div style={{ height: "80vh" }} className='loader'>
          <BeatLoader color={'#AA2A31'} loading={loading} size={30} /></div> :
        <div style={{ marginTop: "2em", paddingBottom: "7em" }} className='container'>
          <div className='noResult'>
            <img src={noResults} />
            <p>{t("dashboard.notFound")} {phone.phone}</p>
            <p>{t("dashboard.fill")}</p>
          </div>
          <div className='editCstmr'>

            {submitLoading ?
              <div style={{ height: "60vh" }} className='loader'>
                <BeatLoader color={'#AA2A31'} loading={submitLoading} size={30} /></div> :
              <form onSubmit={formik.handleSubmit}>

                <p>{t("dashboard.addCstmr")}</p>
                <div>
                  <label> {t("profile.cstmrName")}</label>
                  <input id="name" style={{ width: "100%" }} value={formik.values.name} name="name" ref={nameRef} required={true} onChange={formik.handleChange} onBlur={formik.handleBlur} className={formik.errors.name && formik.touched.name || errorMsgModel ? "invalid" : null} />
                  <span className='validation'>{formik.errors.name && formik.touched.name ? t(`${formik.errors.name}`) : null}</span>

                  <label>  {t("dashboard.cstmrPhone")}</label>
                  <div style={{ display: "flex", width: '100%', gap: "8px", alignItems: "center" }}>
                    {/* Editable Country Code */}
                    {/* <input
                      type="text"
                      name="countryCode"
                      placeholder={formik.values.countryCode}
                      value={formik.values.countryCode}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      readOnly
                      style={{ width: "60px" }}
                      className={formik.errors.countryCode && formik.touched.countryCode || errorMsgModel ? "invalid" : ""}
                    /> */}

                    {/* Phone Number */}
                    <input
                      readOnly
                      type="tel"
                      id="phone"
                      name="phone"
                      placeholder="Phone number"
                      value={formik.values.phone}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      className={formik.errors.phone && formik.touched.phone || errorMsgModel ? "invalid" : ""}
                      style={{ flex: 1 }}
                    />
                  </div>
                  {/* <span className='validation'>{formik.errors.phone && formik.touched.phone ? t(`${formik.errors.phone}`) : null}</span>
                  <label>  {t("dashboard.country")}</label>
                  <select value={selectedCountry} onChange={(e) => {
                    setSelectedCountry(e.target.value)
                  }
                  }>

                    {country && country.map((data, index) =>
                      <option value={data.id} key={data.id}> {i18n.language == "ar" ? data.arName : data.enName}</option>

                    )}


                  </select> */}
                </div>
                {i18n.language == "ar" ?
                  <span style={{ textAlign: "center" }} className='validation'>{errorMsgModel ? msgAr : null}</span> :
                  <span style={{ textAlign: "center" }} className='validation' >{errorMsgModel ? msgEn : null}</span>}
                <button type='submit'>{t("profile.save")}</button>
              </form>}
          </div>
        </div>}</div>
  );
}

export default AddCustomer;

